var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFollowers = function SvgFollowers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 12,
    fill: "#E3ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_468_53175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2002 32.058C33.2002 32.0607 33.2002 32.0634 33.2002 32.0667C30.5043 34.5115 26.9256 36.0007 23.0003 36.0007C19.0743 36.0007 15.4956 34.5115 12.7997 32.0667C12.7997 32.0634 12.7997 32.0607 12.7997 32.058C12.7997 27.9918 15.179 24.4819 18.6209 22.8438C19.9144 24.1339 21.429 24.8291 23.0003 24.8291C24.5723 24.8291 26.0862 24.1339 27.3804 22.8438C30.8222 24.4819 33.2002 27.9918 33.2002 32.058Z",
    fill: "#799EEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 10C26.1162 10 28.6425 12.5256 28.6425 15.6415C28.6425 18.7581 26.1162 23.02 23.0002 23.02C19.8843 23.02 17.358 18.7581 17.358 15.6415C17.358 12.5256 19.8843 10 23.0002 10Z",
    fill: "#799EEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_468_53175",
    x: 4,
    y: 5,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.36587 0 0 0 0 0.9 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_53175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_468_53175",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFollowers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/followers.53756896c3646bf99537a7c29b4a864e.svg";